import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiAuthService } from '../../../services/api-auth.service';
declare var $: any;

@Component({
  selector: 'app-restablecer',
  templateUrl: './restablecer.component.html',
  styleUrls: ['./restablecer.component.css']
})
export class RestablecerComponent implements OnInit {

  public txtCorreo: string = '';
  public correo: string = ''; //Variable para guadar la clase is-invalid que se agrega a las propiedades de los input
  public alerta: boolean = false; //Controla el comportamiento del mensaje de error.

  public errorCorreo: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorNoExiste: string = ''; //Mensaje de error en caso de que no exista el correo

  //Patron que se ejecuta en el ingreso del email en el input
  emailPattern: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  //Creacion del FormGroup con sus determinados campos y sus validators.
  createFormGroup() {
    return new FormGroup({
      correo: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)])
    });
  }

  contactForm: FormGroup;
  constructor(private router: Router, private apiAuth: ApiAuthService) 
  { 
    this.contactForm = this.createFormGroup();
  }

  ngOnInit() {
  }

  //Enviar correo para restablecer la contraseña
  enviar() {
    if (this.validaCampos()) {
      $('#procesando').modal('show');
      let correo = this.contactForm.get('correo').value;
      this.apiAuth.restableceContra(correo).subscribe(data => {
        if (data[0].success) {
          this.alerta = false;
          setTimeout(() => {
            $('#procesando').modal('hide');
            $('#success').modal('show');
          }, 500);
        } else {
          this.alerta = true;
          this.errorNoExiste = data[0].msgRespuesta;
        }
      });
    }
  }

  //Validaciones de campos completos
  validaCampos() {
    let bandValida = true;
    if (this.contactForm.controls.correo.hasError('required')) {
        this.correo = 'is-invalid';
        this.errorCorreo = 'Campo sin completar';
        bandValida = false;
    } else if (this.contactForm.controls.correo.hasError('pattern')){
      bandValida = false;
      this.correo = 'is-invalid';
      this.errorCorreo = 'Formato correo incorrecto';
    } else {
      this.correo = '';
      this.errorCorreo = '';
    }

    return bandValida;
  }

}
